"use client";
"use no memo";
import { Flex } from "@radix-ui/themes";

import { GetClients } from "@/app/actions/clients/actions";
import RadioCardGroup from "@/components/form/RadioCardGroup";
import ModuleLayout from "@/components/layout/ModuleLayout";
import { Button } from "@/components/ui/button";
import { Client } from "@/types/models";
import { Loader2 } from "lucide-react";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";

export default function Create() {
  const [clients, setClients] = useState<Client[]>();
  const [selectedClient, setSelectedClient] = useState<string>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isDataLoading, setIsDataLoading] = useState<boolean>(true);
  const router = useRouter();

  useEffect(() => {
    GetClients().then((resp) => {
      if (resp) {
        setClients(resp.data);
      }
      setIsDataLoading(false);
    });
  }, []);

  const selectClient = () => {
    setIsLoading(true);

    if (!selectedClient) {
      setIsLoading(false);
      return;
    }

    router.push(`/timesheets/create/${selectedClient}`);
  };

  return (
    <ModuleLayout
      title="Create a timesheet"
      subtitle="Select a client"
      footer={
        <Flex justify="end" className="mt-6 w-full">
          <Button
            disabled={!selectedClient || isLoading}
            onClick={() => selectClient()}
          >
            {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Next
          </Button>
        </Flex>
      }
    >
      {isDataLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
      <RadioCardGroup
        name="client"
        onChange={(cl) => {
          setSelectedClient(cl);
        }}
        options={clients?.map((c) => ({
          label: c.name,
          value: c.id,
        }))}
      />
    </ModuleLayout>
  );
}
